import styled from '@emotion/styled';
import React from 'react';
import { ThemeButton } from './ThemeButton';
import { UserDropdown } from './UserDropdown';
const AppBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-border);
  box-sizing: border-box;
  background-color: var(--color-bg-2);
  height: 100%;

  .left {
    display: flex;
    align-items: center;
  }

  .logo {
    display: flex;
    align-items: center;
    width: 200px;
    padding-left: 20px;
    box-sizing: border-box;
  }

  .logo-name {
    color: var(--color-text-1);
    font-weight: 500;
    font-size: 20px;
  }

  .right {
    display: flex;
    list-style: none;
    padding-right: 20px;

    li {
      padding: 0 8px;
      display: flex;
      align-items: center;
    }

    a {
      text-decoration: none;
      color: var(--color-text-1);
    }
  }
`;

function AppBar() {
  return /*#__PURE__*/React.createElement(AppBarWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO_URL,
    alt: "",
    className: "w-10 h-10 rounded-full mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "logo-name"
  }, "\u540E\u53F0\u7BA1\u7406"))), /*#__PURE__*/React.createElement("ul", {
    className: "right"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ThemeButton, null)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(UserDropdown, null))));
}

export default AppBar;